import { InputType } from "../../../schemas/schema.types.js";
import { CommonSchemaIds } from "./common.const.js";
export const COMMON_TLMD_SCHEMAS = {
    [CommonSchemaIds.RANGE]: {
        id: CommonSchemaIds.RANGE,
        schema: {
            type: 'object',
            unevaluatedProperties: false,
            properties: {
                start: {
                    type: 'number'
                },
                end: {
                    type: 'number'
                }
            },
            required: ['start', 'end']
        },
        input: {
            type: InputType.TimeRangeField,
            properties: {
                format: 'epoch',
                fixedType: true
            }
        }
    }
};
